import React from 'react'
import { eraseCookie, getAccessToken, getCookie } from './AuthHelper'
import { BASE_URL, API_URL } from '../constants'

const axios = require('axios')

//static image of client in system

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false
  }
  return true
}

export function isEmptyString(e) {
  switch (e) {
    case '':
    case 0:
    case '0':
    case null:
    case false:
    case typeof e == 'undefined':
      return true
    default:
      return false
  }
}
export function isNonNumeric(e) {
  switch (e) {
    case '':
    case '-':
    case null:
    case typeof e == 'undefined':
      return true
    default:
      return false
  }
}



export function groupBy(data, property) {
  return data.reduce((acc, obj) => {
    const key = obj[property]
    if (!acc[key]) {
      acc[key] = []
    }
    acc[key].push(obj)
    return acc
  }, {})
}

export function logout() {
  eraseCookie('erp_access_token')
  eraseCookie('erp_token_type')
  eraseCookie('erp_refresh_token')
  eraseCookie('erp_expires_in')
  eraseCookie('permission')
  eraseCookie('username')
  localStorage.clear()
  window.location = BASE_URL
}

export function generateErrorString(errors) {
  var finaldata = ''
  for (const property in errors) {
    var error = errors[property][0].split(' ')
    error.shift()
    error.splice(0, 0, property.toUpperCase())
    finaldata += error.join(' ') + '\n'
  }
  return finaldata
}

export function getFormattedDate(date) {
  date = new Date(date)
  let y = date.getFullYear()
  let m = sprintf('%02d', date.getMonth() + 1)
  let d = sprintf('%02d', date.getDate())
  return [y, m, d].join('-')
}

export function getEconomicYearDetailFromId(economicYears, id) {
  var data = economicYears.filter(
    (v, index) => parseInt(v.functionalyearid) === parseInt(id)
  )[0]

  return data
}

function sprintf() {
  var regex = /%%|%(?:(\d+)\$)?((?:[-+#0 ]|'[\s\S])*)(\d+)?(?:\.(\d*))?([\s\S])/g
  var args = arguments
  var i = 0
  var format = args[i++]

  var _pad = function (str, len, chr, leftJustify) {
    if (!chr) {
      chr = ' '
    }
    var padding =
      str.length >= len ? '' : new Array((1 + len - str.length) >>> 0).join(chr)
    return leftJustify ? str + padding : padding + str
  }

  var justify = function (value, prefix, leftJustify, minWidth, padChar) {
    var diff = minWidth - value.length
    if (diff > 0) {
      // when padding with zeros
      // on the left side
      // keep sign (+ or -) in front
      if (!leftJustify && padChar === '0') {
        value = [
          value.slice(0, prefix.length),
          _pad('', diff, '0', true),
          value.slice(prefix.length),
        ].join('')
      } else {
        value = _pad(value, minWidth, padChar, leftJustify)
      }
    }
    return value
  }

  var _formatBaseX = function (
    value,
    base,
    leftJustify,
    minWidth,
    precision,
    padChar
  ) {
    // Note: casts negative numbers to positive ones
    var number = value >>> 0
    value = _pad(number.toString(base), precision || 0, '0', false)
    return justify(value, '', leftJustify, minWidth, padChar)
  }

  // _formatString()
  var _formatString = function (
    value,
    leftJustify,
    minWidth,
    precision,
    customPadChar
  ) {
    if (precision !== null && precision !== undefined) {
      value = value.slice(0, precision)
    }
    return justify(value, '', leftJustify, minWidth, customPadChar)
  }

  // doFormat()
  var doFormat = function (
    substring,
    argIndex,
    modifiers,
    minWidth,
    precision,
    specifier
  ) {
    var number, prefix, method, textTransform, value

    if (substring === '%%') {
      return '%'
    }

    // parse modifiers
    var padChar = ' ' // pad with spaces by default
    var leftJustify = false
    var positiveNumberPrefix = ''
    var j, l

    for (j = 0, l = modifiers.length; j < l; j++) {
      // eslint-disable-next-line default-case
      switch (modifiers.charAt(j)) {
        case ' ':
        case '0':
          padChar = modifiers.charAt(j)
          break
        case '+':
          positiveNumberPrefix = '+'
          break
        case '-':
          leftJustify = true
          break
        case "'":
          if (j + 1 < l) {
            padChar = modifiers.charAt(j + 1)
            j++
          }
          break
      }
    }

    if (!minWidth) {
      minWidth = 0
    } else {
      minWidth = +minWidth
    }

    if (!isFinite(minWidth)) {
      throw new Error('Width must be finite')
    }

    if (!precision) {
      precision =
        specifier === 'd' ? 0 : 'fFeE'.indexOf(specifier) > -1 ? 6 : undefined
    } else {
      precision = +precision
    }

    if (argIndex && +argIndex === 0) {
      throw new Error('Argument number must be greater than zero')
    }

    if (argIndex && +argIndex >= args.length) {
      throw new Error('Too few arguments')
    }

    value = argIndex ? args[+argIndex] : args[i++]

    switch (specifier) {
      case '%':
        return '%'
      case 's':
        return _formatString(
          value + '',
          leftJustify,
          minWidth,
          precision,
          padChar
        )
      case 'c':
        return _formatString(
          String.fromCharCode(+value),
          leftJustify,
          minWidth,
          precision,
          padChar
        )
      case 'b':
        return _formatBaseX(value, 2, leftJustify, minWidth, precision, padChar)
      case 'o':
        return _formatBaseX(value, 8, leftJustify, minWidth, precision, padChar)
      case 'x':
        return _formatBaseX(
          value,
          16,
          leftJustify,
          minWidth,
          precision,
          padChar
        )
      case 'X':
        return _formatBaseX(
          value,
          16,
          leftJustify,
          minWidth,
          precision,
          padChar
        ).toUpperCase()
      case 'u':
        return _formatBaseX(
          value,
          10,
          leftJustify,
          minWidth,
          precision,
          padChar
        )
      case 'i':
      case 'd':
        number = +value || 0
        // Plain Math.round doesn't just truncate
        number = Math.round(number - (number % 1))
        prefix = number < 0 ? '-' : positiveNumberPrefix
        value = prefix + _pad(String(Math.abs(number)), precision, '0', false)

        if (leftJustify && padChar === '0') {
          // can't right-pad 0s on integers
          padChar = ' '
        }
        return justify(value, prefix, leftJustify, minWidth, padChar)
      case 'e':
      case 'E':
      case 'f': // @todo: Should handle locales (as per setlocale)
      case 'F':
      case 'g':
      case 'G':
        number = +value
        prefix = number < 0 ? '-' : positiveNumberPrefix
        method = ['toExponential', 'toFixed', 'toPrecision'][
          'efg'.indexOf(specifier.toLowerCase())
        ]
        textTransform = ['toString', 'toUpperCase'][
          'eEfFgG'.indexOf(specifier) % 2
        ]
        value = prefix + Math.abs(number)[method](precision)
        return justify(value, prefix, leftJustify, minWidth, padChar)[
          textTransform
        ]()
      default:
        // unknown specifier, consume that char and return empty
        return ''
    }
  }

  try {
    return format.replace(regex, doFormat)
  } catch (err) {
    return false
  }
}

export function autoDissaperAction() {
  setTimeout(() => window.location.reload(), 2000)
}

export function fieldRequiredOrNot(module, fieldName) {
  return new Promise(async (resolve) => {
    let erp_access_token = getCookie('erp_access_token')
    let erp_token_type = getCookie('erp_token_type')
    let axiosConfig = {
      headers: {
        authorization: erp_token_type + ' ' + erp_access_token,
        'Content-Type': 'application/json',
      },
    }
    if (erp_access_token != null) {
      var url = `${API_URL}api/displaygeneralsetting/${module}`
      axios
        .get(url, axiosConfig)
        .then(async (response) => {
          if (response.status === 200) {
            let dataObject = response.data.object

            dataObject.map((element, i) => {
              if (element.fieldName === fieldName) {
                if (element.required === true) {
                  resolve('required')
                } else {
                  resolve('not required')
                }
              }
            })
            resolve('required')
          }
        })
        .catch(async (err, code) => {
          if (err.message === 'Request aborted') {
            window.location.reload()
            return
          }
          this.messager.alert({
            title: 'Error',
            icon: 'error',
            msg: 'Internal Server Error',
          })
        })
    } else {
      const resp = await getAccessToken()
      if (resp) {
        this.englishToNepali()
      }
    }
  })
}

export const checkIfLedgerMappingDone = async (masterLedgerName) => {
  var token = getCookie('erp_access_token')
  var tokenType = getCookie('erp_token_type')
  let apiUrl = `${API_URL}api/checkledgermapped/${masterLedgerName}`
  let headersConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${tokenType} ${token}`,
    },
  }
  try {
    var response = await axios.get(apiUrl, headersConfig)
    console.log(response)
    return { error: false, response: response }
  } catch (error) {
    return { error: true, response: error }
  }
}

export const checkIfLedgerMappingDoneMultiple = async (masterLedgerName) => {
  var promises = []
  for (var i = 0; i < masterLedgerName.length; i++) {
    promises.push(checkIfLedgerMappingDone(masterLedgerName[i]))
  }
  return Promise.all(promises)
}

export function clean(obj) {
  for (var propName in obj) {
    // delete obj[propName];
    if (
      obj[propName] === 'null' ||
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === ''
    ) {
      delete obj[propName]
    }
  }

  return obj
}

export function cleanArray(array) {
  var finalData = []
  for (var i = 0; i < array.length; i++) {
    var current = array[i]
    var cleaned = clean(current)
    finalData.push(cleaned)
  }

  return finalData
}

